<template>
    <div class="el-grid-card" style="width: 100%">
        <div class="el-grid-card__body">
            <el-row class="flex justify-between items-center filter-block">
                <el-col :span="18">
                    <el-date-picker
                        id="listDateTimeRange"
                        v-model="dateTimeRange"
                        @change="fetchByDateTimeRange"
                        format="yyyy-MM-dd HH:mm"
                        type="datetimerange"
                        range-separator="-"
                        :clearable="false"
                        :start-placeholder="$t('form.label.dateTimeFrom')"
                        :end-placeholder="$t('form.label.dateTimeUntil')"
                        :picker-options="pickerOptions"
                        class="el-date-picker-light"
                    >
                    </el-date-picker>
                    <v-btn-toggle class="top-data-btn" v-model="activeButton">
                        <v-btn
                            flat
                            color="dark"
                            @click="fetchByDateTimeRange(withinDay)"
                        >
                            {{ $t('button.text.today') }}
                        </v-btn>
                        <v-btn
                            flat
                            color="dark"
                            @click="fetchByDateTimeRange(thisWeek)"
                            style="width: auto"
                        >
                            {{ $t('button.text.thisWeek', { number: 5 }) }}
                        </v-btn>
                        <v-btn
                            flat
                            color="dark"
                            @click="fetchByDateTimeRange(lastWeek)"
                            style="width: auto"
                        >
                            {{ $t('button.text.lastWeek', { number: 7 }) }}
                        </v-btn>
                        <v-btn
                            flat
                            color="dark"
                            @click="fetchByDateTimeRange(thisMonth)"
                            style="width: auto"
                        >
                            {{ $t('button.text.thisMonth', { number: 7 }) }}
                        </v-btn>
                        <v-btn
                            flat
                            color="dark"
                            @click="fetchByDateTimeRange(lastMonth)"
                            style="width: auto"
                        >
                            {{ $t('button.text.lastMonth', { number: 7 }) }}
                        </v-btn>
                        <v-btn
                            @click.prevent="() => downloadExcel()"
                            flat
                            color="dark"
                            style="width: auto"
                        >
                            {{ $t('button.text.downloadSelection') }}
                            <img
                                src="/images/icon/export-excel.png"
                                class="ml-1"
                                style="vertical-align: middle"
                            />
                        </v-btn>
                    </v-btn-toggle>
                </el-col>
                <el-col :span="6">
                    <v-text-field
                        :label="$t('form.label.search')"
                        v-model="searchTerm"
                        append-icon="search"
                        class="el-light-search"
                    ></v-text-field>
                    <vue-multi-select
                        ref="multiSelect"
                        v-model="columnFilterValues"
                        search
                        historyButton
                        :options="columnFilterOptions"
                        :btnLabel="columnFilterBtnLabel"
                        :selectOptions="columnFilterData"
                    >
                        <template v-slot:option="{ option }">
                            <input type="checkbox" :checked="option.selected" />
                            <span>{{ option.name }}</span>
                        </template>
                    </vue-multi-select>
                </el-col>
            </el-row>

            <el-row>
                <el-collapse v-model="activeTab">
                    <el-collapse-item name="1">
                        <el-row>
                            <el-col :span="8">
                                <CustomDoughnutChart
                                    :deliveryAccuracy="deliveryAccuracy"
                                ></CustomDoughnutChart>
                            </el-col>
                            <el-col :span="8">
                                <CustomDoughnutChart2
                                    :deliveryType="deliveryType"
                                ></CustomDoughnutChart2>
                            </el-col>
                            <el-col :span="8">
                                <el-row>
                                    <CustomRadiusChart
                                        :deliveryPrecision="deliveryPrecision"
                                    ></CustomRadiusChart>
                                </el-row>
                                <el-row>
                                    <CustomRoutesChart
                                        :deliveryRoutes="deliveryRoutes"
                                    ></CustomRoutesChart>
                                </el-row>
                            </el-col>
                        </el-row>
                    </el-collapse-item>
                </el-collapse>
            </el-row>

            <el-row>
                <el-table
                    class="el-table__dark-expandable"
                    :data="searchResults"
                    v-loading="loading"
                    :element-loading-text="$t('table.column.loadingText')"
                    row-key="BLCRouteID"
                    ref="table1"
                    @row-click="
                        (row) => {
                            rowClicked(row, $refs.table1)
                        }
                    "
                    style="width: 100%"
                    border
                >
                    <el-table-column
                        v-if="columnFilterValues.includes(
                                columnFilterInclusionList[0]
                            )"
                        sortable
                        :label="$t('table.column.status')"
                        prop="StatusDescription"
                    >
                        <template slot-scope="{ row }">
                            {{
                                $t(`status.${row.StatusDescription}`) ||
                                row.StatusDescription
                            }}
                            <img
                                src="/images/icon/images-icon-black.png"
                                style="
                                    right: 8px;
                                    width: 20px;
                                    position: absolute;
                                "
                                v-if="
                                    isImagesAvailable(
                                        row.ActorDeliveryConfirmation
                                    )
                                "
                            />
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnFilterValues.includes(
                                columnFilterInclusionList[1]
                            )"
                        sortable
                        :label="$t('table.column.BLCRoute')"
                        prop="Reference"
                    >
                    </el-table-column>
                    <el-table-column
                        v-if="columnFilterValues.includes(
                                columnFilterInclusionList[2]
                            )"
                        sortable
                        width="170"
                        :label="$t('table.column.deliveryPrecision')"
                        prop="DeliveryPrecision"
                    >
                        <template slot-scope="{ row }">
                            {{ row.DeliveryPrecision }}<span>%</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-for="column in columnFilterDynamicValues"
                        :key="column"
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, column)"
                        :prop="column"
                        :label="setColumnHeaderLabel(column)"
                    ></el-table-column>
                    <el-table-column :label="$t('table.column.download')">
                        <template slot-scope="{ row }">
                            <button
                                class="hover:underline"
                                @click.prevent="
                                    () => downloadExcelForRoute(row)
                                "
                            >
                                <img
                                    src="/images/icon/export-excel.png"
                                    style="vertical-align: middle"
                                />
                            </button>
                            &nbsp;
                            <button
                                @click.prevent="() => downloadZipForRoute(row)"
                            >
                                <img
                                    src="/images/icon/export-zip.png"
                                    style="vertical-align: middle"
                                />
                            </button>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('table.column.operations')"
                        width="100"
                    >
                        <template slot-scope="{ row }">
                            <div class="btn-action-wrapper">
                                <a
                                    href="#"
                                    class="btn-action"
                                    @click.stop="
                                        openTimeline(
                                            row.BLCRouteID,
                                            'BLC_ROUTE',
                                            row.Reference
                                        )
                                    "
                                >
                                    <v-btn flat icon color="info darken-3">
                                        <v-icon>info</v-icon>
                                    </v-btn>
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :resizable="false" type="expand">
                        <template slot-scope="{ row }">
                            <el-table
                                class="
                                    el-table__dark-expandable
                                    el-table__inner-dark-expandable
                                "
                                :data="row.ActorDeliveryConfirmation"
                                ref="table2"
                                @row-click="
                                    (row) => {
                                        rowClicked(row, $refs.table2)
                                    }
                                "
                                style="width: 100%"
                                border
                            >
                                <el-table-column
                                    width="75"
                                    :label="$t('table.column.express')"
                                    prop="Express"
                                >
                                    <template slot-scope="{ row }">
                                        <button v-show="row.Actor.IsExpress">
                                            <img
                                                src="/images/icon/express.png"
                                                style="vertical-align: middle"
                                            />
                                        </button>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    width="100"
                                    :label="$t('table.column.booking')"
                                    prop="Actor.BookingReference"
                                >
                                </el-table-column>
                                <el-table-column
                                    width="250"
                                    :label="$t('table.column.destination')"
                                    prop="Destination"
                                >
                                </el-table-column>
                                <el-table-column
                                    width="110"
                                    :label="$t('table.column.accuracy')"
                                >
                                    <template slot-scope="{ row }">
                                        {{
                                            row.Accuracy &&
                                            $t(`accuracy.${row.Accuracy}`)
                                        }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    width="160"
                                    :label="$t('table.column.plannedDelivery')"
                                    prop="PlannedDelivery"
                                >
                                </el-table-column>
                                <el-table-column
                                    width="150"
                                    :label="$t('table.column.actualDelivery')"
                                    prop="ActualDelivery"
                                >
                                </el-table-column>
                                <el-table-column
                                    width="120"
                                    :label="
                                        $t('table.column.deliveredPackages')
                                    "
                                    prop="DeliveredPackageCount"
                                >
                                </el-table-column>
                                <el-table-column
                                    width="180"
                                    :label="$t('table.column.recipient')"
                                >
                                    <template slot-scope="{ row }">
                                        {{
                                            row.Recipients.length
                                                ? row.Recipients.join(', ')
                                                : '(Delivery without signature)'
                                        }}
                                        <img
                                            src="/images/icon/images-icon-black.png"
                                            style="
                                                right: 8px;
                                                width: 20px;
                                                position: absolute;
                                            "
                                            v-if="isImagesAvailable2(row)"
                                        />
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    min-width="120"
                                    :label="$t('table.column.comments')"
                                >
                                    <template slot-scope="{ row }">
                                        {{
                                            row.Comments.length
                                                ? row.Comments.join(', ')
                                                : ''
                                        }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    min-width="150"
                                    :label="$t('table.column.download')"
                                >
                                    <template slot-scope="{ row }">
                                        <button
                                            @click.prevent="
                                                () => downloadExcelForActor(row)
                                            "
                                        >
                                            <img
                                                src="/images/icon/export-excel.png"
                                                style="vertical-align: middle"
                                            />
                                        </button>
                                        &nbsp;
                                        <button
                                            @click="
                                                () => downloadZipForActor(row)
                                            "
                                        >
                                            <img
                                                src="/images/icon/export-zip.png"
                                                style="vertical-align: middle"
                                            />
                                        </button>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :label="$t('table.column.operations')"
                                    width="100"
                                >
                                    <template slot-scope="{ row }">
                                        <div class="btn-action-wrapper">
                                            <a
                                                href="#"
                                                class="btn-action"
                                                @click.stop="
                                                    openTimeline(
                                                        row.ActorID,
                                                        'ACTOR',
                                                        row.Actor
                                                            .BookingReference
                                                    )
                                                "
                                            >
                                                <v-btn
                                                    flat
                                                    icon
                                                    color="info darken-3"
                                                >
                                                    <v-icon>info</v-icon>
                                                </v-btn>
                                            </a>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column type="expand" width="35">
                                    <template slot-scope="{ row }">
                                        <el-row>
                                            <div
                                                class="
                                                    el-table__inner-row-content
                                                    el-table__inner-row-content--dark
                                                "
                                            >
                                                <viewer
                                                    :images="row.allImages"
                                                    :options="viewerOptions"
                                                >
                                                    <img
                                                        v-for="image in row.allImages"
                                                        :key="image.ImageID"
                                                        :src="image.src"
                                                        class="img-thumbnail"
                                                    />
                                                </viewer>
                                            </div>
                                        </el-row>
                                        <el-row
                                            v-if="row.Actor"
                                            v-for="packageGroup in row.Actor
                                                .PackageGroups"
                                            :key="packageGroup.PackageGroupID"
                                        >
                                            <div
                                                class="
                                                    el-table__inner-row-content
                                                    el-table__inner-row-content--dark
                                                "
                                            >
                                                <el-row>
                                                    <ul
                                                        class="
                                                            el-table__inner-row-inline-list
                                                        "
                                                    >
                                                        <li>
                                                            <span
                                                                class="
                                                                    label
                                                                    pr-1
                                                                "
                                                                >{{
                                                                    $t(
                                                                        'table.data.label.rref'
                                                                    )
                                                                }}:</span
                                                            ><span
                                                                class="value"
                                                                >{{
                                                                    packageGroup.Reference
                                                                        | hyphenize
                                                                }}</span
                                                            >
                                                        </li>
                                                        <li>
                                                            <span
                                                                class="
                                                                    label
                                                                    pr-1
                                                                "
                                                                >{{
                                                                    $t(
                                                                        'table.data.label.order'
                                                                    )
                                                                }}:</span
                                                            ><span
                                                                class="value"
                                                                >{{
                                                                    packageGroup.OrderNo
                                                                        | hyphenize
                                                                }}</span
                                                            >
                                                        </li>
                                                        <li>
                                                            <span
                                                                class="
                                                                    label
                                                                    pr-1
                                                                "
                                                                >{{
                                                                    $t(
                                                                        'table.data.label.supplier'
                                                                    )
                                                                }}:</span
                                                            ><span
                                                                class="value"
                                                                >{{
                                                                    packageGroup.SupplierName
                                                                        | hyphenize
                                                                }}</span
                                                            >
                                                        </li>
                                                        <li>
                                                            <v-icon
                                                                color="info darken-3"
                                                                style="
                                                                    cursor: pointer;
                                                                "
                                                                @click.stop="
                                                                    openTimeline(
                                                                        packageGroup.PackageGroupID,
                                                                        'PACKAGE_GROUP',
                                                                        packageGroup.ReferenceCode
                                                                    )
                                                                "
                                                                >info</v-icon
                                                            >
                                                        </li>
                                                    </ul>
                                                </el-row>
                                                <el-table
                                                    class="
                                                        el-table__dark-expandable
                                                        el-table__inner-transparent
                                                    "
                                                    :data="
                                                        packageGroup.PackageItems
                                                    "
                                                    style="width: 100%"
                                                >
                                                    <el-table-column
                                                        :label="
                                                            $t(
                                                                'table.column.description'
                                                            )
                                                        "
                                                    >
                                                        <template
                                                            slot-scope="{ row }"
                                                        >
                                                            {{
                                                                row.Description
                                                                    | hyphenize
                                                            }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        :label="
                                                            $t(
                                                                'table.column.trackingReference'
                                                            )
                                                        "
                                                        width="250"
                                                    >
                                                        <template
                                                            slot-scope="{ row }"
                                                        >
                                                            {{
                                                                row.TrackingReference
                                                                    | hyphenize
                                                            }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        :label="
                                                            $t(
                                                                'table.column.customerReference'
                                                            )
                                                        "
                                                        width="250"
                                                    >
                                                        <template
                                                            slot-scope="{ row }"
                                                        >
                                                            {{
                                                                row.CustomReference
                                                                    | hyphenize
                                                            }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        :label="
                                                            $t(
                                                                'table.column.height'
                                                            )
                                                        "
                                                        width="100"
                                                    >
                                                        <template
                                                            slot-scope="{ row }"
                                                        >
                                                            {{
                                                                row.Height
                                                                    | hyphenize
                                                            }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        :label="
                                                            $t(
                                                                'table.column.width'
                                                            )
                                                        "
                                                        width="90"
                                                    >
                                                        <template
                                                            slot-scope="{ row }"
                                                        >
                                                            {{
                                                                row.Width
                                                                    | hyphenize
                                                            }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        :label="
                                                            $t(
                                                                'table.column.length'
                                                            )
                                                        "
                                                        width="90"
                                                    >
                                                        <template
                                                            slot-scope="{ row }"
                                                        >
                                                            {{
                                                                row.Length
                                                                    | hyphenize
                                                            }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        :label="
                                                            $t(
                                                                'table.column.weight'
                                                            )
                                                        "
                                                        width="90"
                                                    >
                                                        <template
                                                            slot-scope="{ row }"
                                                        >
                                                            {{
                                                                row.Weight
                                                                    | hyphenize
                                                            }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        :label="
                                                            $t(
                                                                'table.column.deliveryStatus'
                                                            )
                                                        "
                                                        width="150"
                                                    >
                                                        <template
                                                            slot-scope="{ row }"
                                                        >
                                                            {{
                                                                $t(
                                                                    `status.${row.StatusDescription}`
                                                                ) ||
                                                                row.StatusDescription
                                                            }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        :label="
                                                            $t(
                                                                'table.column.operations'
                                                            )
                                                        "
                                                        width="100"
                                                    >
                                                        <template
                                                            slot-scope="{ row }"
                                                        >
                                                            <div
                                                                class="
                                                                    btn-action-wrapper
                                                                "
                                                            >
                                                                <a
                                                                    href="#"
                                                                    class="
                                                                        btn-action
                                                                    "
                                                                    @click.stop="
                                                                        openTimeline(
                                                                            row.PackageItemID,
                                                                            'PACKAGE_ITEM',
                                                                            row.ReferenceCode
                                                                        )
                                                                    "
                                                                >
                                                                    <v-btn
                                                                        flat
                                                                        icon
                                                                        color="info darken-3"
                                                                    >
                                                                        <v-icon
                                                                            >info</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </a>
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </el-row>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next"
                    :page-count="totalPages"
                    :total="totalCount"
                    :current-page="currentPage"
                    :page-sizes="[20, 30, 40, 50, 100]"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    style="margin-top: 10px"
                >
                </el-pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import FileSaver from 'file-saver'
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import InteractWithDates from '../../mixins/interact-with-dates'
import CustomDoughnutChart from './CustomDoughnutChart'
import CustomDoughnutChart2 from './CustomDoughnutChart2'
import CustomRadiusChart from './CustomRadiusChart'
import CustomRoutesChart from './CustomRoutesChart'
import 'viewerjs/dist/viewer.css'
import vueMultiSelect from 'vue-multi-select'
import 'vue-multi-select/dist/lib/vue-multi-select.css'

export default {
    name: 'follow-up-list',

    mixins: [InteractWithDates],

    components: {
        CustomRoutesChart,
        CustomRadiusChart,
        CustomDoughnutChart,
        CustomDoughnutChart2,
        vueMultiSelect,
    },

    data() {
        return {
            activeButton: 0,
            dateTimeRange: [],
            data: [],
            loading: false,
            downloading: false,
            searchTerm: '',
            searchResults: [],
            activeTab: '1',
            deliveryAccuracy: {
                ONTIME: 0,
                TOOEARLY: 0,
                TOOLATE: 0,
            },
            deliveryType: {
                EXPRESS_ONLY: 0,
                NON_EXPRESS: 0,
            },
            deliveryPrecision: 0,
            deliveryRoutes: 0,
            totalPages: 1,
            currentPage: 1,
            totalCount: 0,
            pageSize: 20,
            viewerOptions: {
                toolbar: true,
                movable: true,
                zoomable: true,
                scalable: false,
                rotatable: false,
                fullscreen: false,
                title: false,
            },

            columnFilterExclusionList: ['StatusDescription', 'Reference', 'DeliveryPrecision'],
            columnFilterInclusionList: ['StatusDescription', 'BLCReference', 'DeliveryPrecision'],
            columnFilterDefault: [
                'RouteDate',
                'DriverUserFullName',
                'VehicleDescription'
            ],
            columnFilterValues: [],
            columnFilterData: [],
            columnFilterOptions: {
                multi: true,
            },
            columnFilterBtnLabel: (values) =>
                `Columns selected (${values.length})`,
        }
    },

    filters: {
        hyphenize: function (value) {
            if (!value) return '-'
            return value
        },
    },

    computed: {
        ...mapGetters(['isBlc', 'selectedContainer']),

        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },

        searchOptions() {
            return {
                keys: [
                    'Reference',
                    'VehicleDescription',
                    'Actors.PackageGroups.OrderNo',
                    'Actors.PackageGroups.SupplierName',
                    'ActorDeliveryConfirmation.Comments',
                    'ActorDeliveryConfirmation.Recipients',
                    'ActorDeliveryConfirmation.Destination',
                ],
            }
        },

        followUpItems() {
            return this.data.map((item) => {
                const ActorDeliveryConfirmation =
                    item.ActorDeliveryConfirmation.map((confirmation) => {
                        const photos = confirmation.ImagePaths.map((image) => {
                            return {
                                ...image,
                                src: image.ImagePath,
                                thumb: image.ImagePath,
                            }
                        })
                        const signatures = confirmation.SignatureImagePaths.map(
                            (signature) => ({
                                src: signature.ImagePath,
                                thumb: signature.ImagePath,
                            })
                        )

                        return {
                            ...confirmation,
                            Actor: _.find(item.Actors, [
                                'ActorID',
                                confirmation.ActorID,
                            ]),
                            BLCRouteID: item.BLCRouteID,
                            Photos: photos,
                            Signatures: signatures,
                            allImages: [...photos, ...signatures],
                            ActualDelivery: confirmation.DeliveredDates.length
                                ? DateTime.fromISO(
                                      confirmation.DeliveredDates[0]
                                  ).toFormat('yyyy-MM-dd HH:mm')
                                : '',
                            PlannedDelivery:
                                confirmation.PlannedDeliveryDateString,
                        }
                    })

                return {
                    ...item,
                    RouteDate: DateTime.fromISO(item.RouteDate).toFormat(
                        'yyyy-MM-dd HH:mm'
                    ),
                    ActorDeliveryConfirmation,
                }
            })
        },

        columnFilterDynamicValues() {
            const filtered = this.columnFilterValues.filter(
                (item) => !this.columnFilterInclusionList.includes(item)
            )
            return filtered
        },
    },

    watch: {
        selectedContainer: function (container) {
            if (this.withPermission) {
                this.redirectIfNotBlc()
            }
            this.fetch(container, this.dateTimeRange)
        },
        searchTerm: _.debounce(async function () {
            if (this.searchTerm !== '') {
                this.searchResults = await this.$search(
                    this.searchTerm,
                    this.followUpItems,
                    this.searchOptions
                )
            } else {
                this.searchResults = this.followUpItems
            }
        }, 500),
    },

    created() {
        this.redirectIfNotBlc()

        this.fetch()
        this.deliveryAccuracy = {
            ONTIME: 0,
            TOOEARLY: 0,
            TOOLATE: 0,
        }
    },

    methods: {
        handleCurrentChange(val) {
            this.currentPage = val
            this.fetch(this.selectedContainer, this.dateTimeRange, true)
        },

        handleSizeChange(val) {
            this.pageSize = val
            this.fetch(this.selectedContainer, this.dateTimeRange, true)
        },

        isImagesAvailable(actorDeliveryConfirmationList) {
            if (
                actorDeliveryConfirmationList &&
                actorDeliveryConfirmationList.length > 0
            ) {
                for (const item of actorDeliveryConfirmationList) {
                    if (item && item.allImages && item.allImages.length > 0) {
                        return true
                    }
                }
            } else {
                return false
            }
        },

        isImagesAvailable2(item) {
            if (item && item.allImages && item.allImages.length > 0) {
                return true
            }
        },

        async getDeliveryStatisticsData() {
            let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

            let dateTimeFrom = DateTime.fromISO(
                this.dateTimeRange[0].toISOString()
            ).toFormat(dateTimeFormat)
            let dateTimeTo = DateTime.fromISO(
                this.dateTimeRange[1].toISOString()
            ).toFormat(dateTimeFormat)

            let requestObj = {
                DateTimeFrom: dateTimeFrom,
                DateTimeTo: dateTimeTo,
                Container: this.selectedContainer.ContainerID,
            }

            let { data } = await this.$http.post(
                `DeliveryStatistics`,
                requestObj
            )

            if (data) {
                this.deliveryAccuracy = data['DELIVERY_ACCURACY']
                this.deliveryType = data['DELIVERY_TYPE']
                this.deliveryPrecision = data['DELIVERY_PRECISION']
                this.deliveryRoutes = data['DELIVERY_ROUTES']
            }
        },
        async downloadDownloadDeliveryStatics() {
            let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

            let dateTimeFrom = DateTime.fromISO(
                this.dateTimeRange[0].toISOString()
            ).toFormat(dateTimeFormat)
            let dateTimeTo = DateTime.fromISO(
                this.dateTimeRange[1].toISOString()
            ).toFormat(dateTimeFormat)

            let requestObj = {
                DateTimeFrom: dateTimeFrom,
                DateTimeTo: dateTimeTo,
                Container: this.selectedContainer.ContainerID,
            }

            await this.$http.post(`DownloadDeliveryStatics`, requestObj)
        },
        redirectIfNotBlc() {
            if (!this.isBlc) {
                this.$router.push({ name: 'dashboard' })

                return
            }
        },

        fetchByDateTimeRange(range) {
            this.activeButton = ''
            this.dateTimeRange = range
            this.fetch(this.selectedContainer, range)
        },

        async fetch(container = null, range = [], loading = true) {
            this.searchTerm = ''
            this.loading = loading

            container = container ? container : this.selectedContainer

            if (!_.isEmpty(container)) {
                range = range.length ? range : this.withinDay

                let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

                let dateTimeFrom = DateTime.fromISO(range[0].toISOString())
                let dateTimeTo = DateTime.fromISO(range[1].toISOString())

                // set end and start time to day start and day end if it doesn't contains time
                if (
                    dateTimeFrom.startOf('day').valueOf() ===
                        dateTimeFrom.valueOf() &&
                    dateTimeTo.startOf('day').valueOf() === dateTimeTo.valueOf()
                ) {
                    let start = dateTimeFrom.startOf('day')
                    let end = dateTimeTo.endOf('day')

                    dateTimeFrom = start.toFormat(dateTimeFormat)
                    dateTimeTo = end.toFormat(dateTimeFormat)

                    range = [start.toJSDate(), end.toJSDate()]
                } else {
                    dateTimeFrom = dateTimeFrom.toFormat(dateTimeFormat)
                    dateTimeTo = dateTimeTo.toFormat(dateTimeFormat)
                }

                let requestObj = {
                    DateTimeFrom: dateTimeFrom,
                    DateTimeTo: dateTimeTo,
                    ContainerID: this.selectedContainer.ContainerID,
                    CurrentPage: this.currentPage,
                    PageSize: this.pageSize,
                }

                try {
                    let { data } = await this.$http.post(
                        `Route/Search`,
                        requestObj
                    )

                    if (data && data.result) {
                        this.data = data.result
                        this.totalPages = data.TotalPages
                        this.currentPage = data.CurrentPage
                        this.totalCount = data.TotalCount
                        this.setColumns(this.data)
                    }
                } catch (e) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                    this.loading = false
                }

                this.searchResults = this.followUpItems

                this.dateTimeRange = range

                this.getDeliveryStatisticsData()
            }

            this.loading = false
        },

        rowClicked(row, table) {
            this.$nextTick(() => {
                if (this.downloading) return

                table.toggleRowExpansion(row)
            })
        },

        async downloadExcel() {
            this.downloading = true

            let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

            let dateTimeFrom = DateTime.fromISO(
                this.dateTimeRange[0].toISOString()
            ).toFormat(dateTimeFormat)
            let dateTimeTo = DateTime.fromISO(
                this.dateTimeRange[1].toISOString()
            ).toFormat(dateTimeFormat)

            const { data } = await this.$http.get(
                `/BLC/${this.selectedContainer.ContainerID}/Followupsheet/Start/${dateTimeFrom}/End/${dateTimeTo}`,
                {
                    responseType: 'blob',
                }
            )
            FileSaver.saveAs(new Blob([data]), 'followup.xlsx')

            this.downloading = false
        },

        async downloadExcelForRoute(row) {
            this.downloading = true

            const { data } = await this.$http.get(
                `/BLC/${this.selectedContainer.ContainerID}/Followupsheet/${row.BLCRouteID}`,
                {
                    responseType: 'blob',
                }
            )
            FileSaver.saveAs(
                new Blob([data]),
                `followup-route-${row.Reference}.xlsx`
            )

            this.downloading = false
        },

        async downloadExcelForActor(row) {
            this.downloading = true

            const { data } = await this.$http.get(
                `/BLC/${this.selectedContainer.ContainerID}/Followupsheet/${row.BLCRouteID}/Actor/${row.ActorID}`,
                {
                    responseType: 'blob',
                }
            )
            FileSaver.saveAs(
                new Blob([data]),
                `followup-actor-${row.Reference}.xlsx`
            )

            this.downloading = false
        },

        async downloadZipForRoute(row) {
            this.downloading = true

            const { data } = await this.$http.get(
                `/BLC/${row.BLCRouteID}/DownloadRouteImagesZip`,
                {
                    responseType: 'blob',
                }
            )
            FileSaver.saveAs(
                new Blob([data]),
                `followup-route-${row.Reference}.zip`
            )

            this.downloading = false
        },

        async downloadZipForActor(row) {
            this.downloading = true

            const { data } = await this.$http.get(
                `/BLC/${row.BLCRouteID}/DownloadRouteImagesZip/Actor/${row.ActorID}`,
                {
                    responseType: 'blob',
                }
            )
            FileSaver.saveAs(
                new Blob([data]),
                `followup-actor-${row.Reference}.zip`
            )

            this.downloading = false
        },

        openTimeline(id, type, code) {
            Events.$emit('show-timeline', id, type, code)
        },

        setColumns(response) {
            if (response && response[0]) {
                const filtered = Object.keys(response[0]).filter(
                    (item) => !this.columnFilterExclusionList.includes(item)
                )
                filtered.push(...this.columnFilterInclusionList)
                this.columnFilterData = filtered
                this.columnFilterValues = [
                    ...this.columnFilterDefault,
                    ...this.columnFilterInclusionList,
                ]
            }
        },

        setColumnHeaderLabel(columnHeader) {
            const header = columnHeader[0].toLowerCase() + columnHeader.slice(1)
            return this.$t('table.column.' + header)
        },
    },
}
</script>
<style>
.vue-lb-content {
    background-color: black !important;
    padding: 20px !important;
}
.el-collapse-item__arrow {
    color: black;
}
.el-table__empty-block {
    min-height: 90px;
}
.img-thumbnail {
    width: 80px;
    height: 80px;
    margin: 10px;
    cursor: pointer;
}

.checkBoxContainer .selectItem span {
    margin-left: 5px;
}
.checkboxLayer .clearButton {
    height: 23px !important;
}
</style>
